import { useTranslation } from 'react-i18next';

import { useNavigationContext } from 'contexts/SchemableFormNavigationContext/SchemableFormNavigationContext';
import { SuggestionNavigableItem } from 'services/suggestionNavigation/types';
import { useAnalytics } from 'support/helpers/analytics/analytics';
import { SingleSparkleIcon } from 'components/CustomIcons/SingleSparkleIcon';
import { AnnotationNavigationActions } from 'components/WebEDI/AnnotationNavigationActions/AnnotationNavigationActions';

export const SuggestionChangesNavigation = ({ numberOfChanges }: { numberOfChanges: number }) => {
  const { t } = useTranslation();
  const { track } = useAnalytics();
  const { service } = useNavigationContext<SuggestionNavigableItem>();
  const resetFocus = service.resetFocus;

  const moveToNext = () => {
    const previousItem = service.getCurrentItem();
    track('suggestion:next_change', { previousItem });
    service.moveToNextItem();
  };

  const moveToPrevious = () => {
    const previousItem = service.getCurrentItem();
    track('suggestion:previous_change', { previousItem });
    service.moveToPreviousItem();
  };

  if (numberOfChanges === 0) {
    return null;
  }

  return (
    <AnnotationNavigationActions
      leadingContent={
        <span className="inline-flex items-center gap-1.5 text-xs font-medium text-gray-700">
          <SingleSparkleIcon className="size-4" />
          {t('webedi:suggestionModal.changesBanner.badge', { count: numberOfChanges, numberOfChanges })}
        </span>
      }
      totalNumberOfAnnotations={numberOfChanges}
      onPrev={moveToPrevious}
      onNext={moveToNext}
      prevAnalyticsId="webedi:agent_suggestion_previous_change"
      nextAnalyticsId="webedi:agent_suggestion_next_change"
      onFocus={resetFocus}
      focusAnalyticsId="webedi:agent_suggestion_focus_first_change"
      focusLabel={t('webedi:suggestionModal.changesBanner.focusOnChange')}
    />
  );
};
